"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var CustomerAddressesPage = /*#__PURE__*/function (_window$AbstractView) {
    _inherits(CustomerAddressesPage, _window$AbstractView);

    var _super = _createSuper(CustomerAddressesPage);

    function CustomerAddressesPage(id, options) {
      var _this;

      _classCallCheck(this, CustomerAddressesPage);

      _this = _super.call(this, id, options);
      var ADDRESS_PARAMS = window.urlSearchParamsToObject();

      if (ADDRESS_PARAMS.edit === "") {
        // ADD A NEW ADDRESS
        _this.$domElement.find(".customer-addresses-page__edit-address").remove();

        _this.$domElement.find(".addresses-list-row .addresses-list__add-address-btn").remove();
      } else {
        if (_this.$domElement.find('.customer-addresses-page__edit-address[data-ref="' + ADDRESS_PARAMS.edit + '"]').length) {
          // EDIT AN EXISTING ADDRESS
          _this.$domElement.find('.customer-addresses-page__edit-address:not([data-ref="' + ADDRESS_PARAMS.edit + '"])').remove();

          _this.$domElement.find(".customer-addresses-page__new-address").remove();

          _this.$domElement.find(".addresses-list-row").remove();
        } else {
          // ADDRESSES LIST
          _this.$domElement.find(".customer-addresses-page__new-address").remove();

          _this.$domElement.find(".customer-addresses-page__edit-address").remove();
        }
      }

      return _this;
    }

    _createClass(CustomerAddressesPage, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        var $form = this.$domElement.find("form");

        if ($form.length) {
          _get(_getPrototypeOf(CustomerAddressesPage.prototype), "addModules", this).call(this, new AddressFormValidator("address-form-validator__new-address", {
            $domElement: $form
          }));
        }

        if (Shopify) {
          if (this.$domElement.find("select.address-country-select").length) {
            new Shopify.CountryProvinceSelector($('select.address-country-select').attr("id"), $('select.address-province-select').attr("id"), {
              hideElement: null
              /*$('.address-province-select-container').attr("id")*/

            });
          }

          if (this.$domElement.find('.address-edit-toggle').length) {
            this.$domElement.find('.address-edit-toggle').one('click', function (event) {
              event.stopPropagation();
              event.preventDefault();
              Turbolinks.visit("/account/addresses");
            });
          }

          if (this.$domElement.find('.address-new-toggle').length) {
            this.$domElement.find('.address-new-toggle').one('click', function (event) {
              event.stopPropagation();
              event.preventDefault();
              Turbolinks.visit("/account/addresses");
            });
          }

          if (this.$domElement.find("select.address-country-select").length) {
            this.$domElement.find("select.address-country-select").on("change", function (event) {
              _this2.$domElement.find(".address-province-select-container").attr("disabled", !$("select.address-province-select").find("option").length);
            });
            this.$domElement.find("select.address-country-select").trigger("change");
          }
        }

        _get(_getPrototypeOf(CustomerAddressesPage.prototype), "init", this).call(this);
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.$domElement.find(".address-province-select-container").off('change');
        this.$domElement.find('.address-edit-toggle').off('click');
        this.$domElement.find('.address-new-toggle').off('click');

        _get(_getPrototypeOf(CustomerAddressesPage.prototype), "dispose", this).call(this);
      }
    }]);

    return CustomerAddressesPage;
  }(window.AbstractView);

  window.CustomerAddressesPage = CustomerAddressesPage;
})(window);
